import { Skeleton } from '@zorro/design-system/v2/Skeleton';

export const AppLayoutSidebarItemSkeleton = () => {
  return <Skeleton height="3.5rem" mb="xs" radius={8} />;
};
